import { render, staticRenderFns } from "./ClicNotification.vue?vue&type=template&id=607cdcd1&"
import script from "./ClicNotification.vue?vue&type=script&lang=js&"
export * from "./ClicNotification.vue?vue&type=script&lang=js&"
import style0 from "./ClicNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports